<template>
    <div>
        <!--
            Replaced with skeleton
            <FullPageLoader :isLoading="saving || loading"/>
        -->

        <!-- <ContractsRecordCreateModal
            :show="show_create_modal"
            :status="create_status"
            :customerEmail="_.has(record.step2, 'customer') ? record.step2.customer.email : ''"
            @create="create"
            @cancelCreatingContract="cancelCreatingContract"
        /> -->

        <ContractsRecordEndContractModal
            :show="show_end_contract_modal"
            :record="record"
            @closeEndContractModal="closeEndContractModal"
            @reload="startUp"
            @showCreditInvoiceModal="showCreditInvoiceModal"
        />

        <ContractsRecordConfirmStopModal
            :show="show_confirm_stop_modal"
            :type="confirmStopType"
            :record="record"
            @closeConfirmStopModal="show_confirm_stop_modal = false"
            @showCreditInvoiceModal="showCreditInvoiceModal"
            @reload="startUp"
        />

        <ChangePaymentTypeModal
            :show="show_change_payment_type_modal"
            :contract="record"
            @close="show_change_payment_type_modal = false"
            @success="handleChangePaymentSuccess"
        />

        <div class="row">
            <div class="column medium-4 text-right float-right">
                <b-button v-if="mode == 'new'" type="is-light">
                    <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                        <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :disabled="!_.isNull(record.step2.customer_id) && activeStep == 1" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                    </b-tooltip>
                </b-button>

                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" to="/panel/contracten/" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-8">
                <h1>{{ pageTitle }}</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form">
                    <b-tabs size="is-medium" class="block" v-model="tabIndex">
                        <b-tab-item label="Algemeen">
                            <!-- Actie vereist! -->
                            <div v-if="confirmStop && mode == 'view'">
                                <br>
                                <b-notification type="is-warning is-light" role="alert">
                                    <div class="text-center">
                                        <h3>Actie vereist!</h3>
                                        <p>
                                            <strong>Dit contract is aflopend. Wil je het contract beëindigen of het contract verlengen?</strong><br>
                                            Indien het contract gestopt wordt, zal dit op de gebruikelijke datum van afloop gebeuren: {{ moment(record.step1.end_date).format('DD-MM-YYYY') }}.<br>
                                            Indien het contract doorloopt wordt er nog een factuur aangemaakt.
                                        </p>
                                        <p v-if="hideEndingContract">Deze actie kan enkel door de administrator uitgevoerd worden.</p>
                                        <div v-else>
                                            <b-button type="is-success" @click="promptConfirmStop('stop')">Contract stoppen</b-button>
                                            <br>
                                            <br>
                                            <b-button type="is-danger" @click="promptConfirmStop('extend')">Verlengen met 1 maand</b-button>
                                            <b-button type="is-danger" @click="promptConfirmStop('extend_noend')">Verlengen zonder einddatum</b-button>
                                        </div>
                                    </div>
                                </b-notification>
                                <br>
                            </div>
                            <div v-if="record?.step1?.contractInQueue || record?.step1?.hold == 1">
                                <!-- Contract on hold - waiting for signing -->
                                <b-notification type="is-warning is-light" role="alert" v-if="!!record?.step1?.hold">
                                    <p class="marginbottom0"><strong>Let op:</strong>&nbsp;Het contract wordt verstuurd zodra alle contractdocumenten door de klant zijn ondertekend. De klant heeft een e-mail ontvangen met een link om de documenten digitaal te ondertekenen.</p>
                                </b-notification>
                                <!-- Normal flow - send in one hour -->
                                <b-notification type="is-info is-light" role="alert" v-else>
                                    <p class="marginbottom0"><strong>Let op:</strong>&nbsp;De bevestigingsmail<span v-if="record?.step1?.contractInQueueWithPDFs">, inclusief bijlagen,</span> wordt ongeveer een uur na het aanmaken van het contract verstuurd. <span v-if="record?.step1?.contractInQueueWithPDFs">Dit geeft voldoende tijd om het contract te ondertekenen.</span></p>
                                </b-notification>
                                <br>
                            </div>
                            <div v-if="record?.step1?.pending_addendum == 1 && pendingAddendum">
                                <b-notification type="is-warning is-light" role="alert">
                                    <p class="marginbottom0">
                                        <strong>Let op:</strong>&nbsp;
                                        Er staat een contractaanpassing open
                                        <span v-if="pendingAddendum.status === 'pending_signature'"> die nog bevestigd moet worden.</span>
                                        <span v-else-if="pendingAddendum.status === 'pending_processing' && Number(pendingAddendum.require_signing || 0) === 0">
                                            die automatisch wordt verwerkt op {{ moment(pendingAddendum.effective_date).format('DD-MM-YYYY') }}.
                                        </span>
                                        <span v-else>.</span>
                                        <router-link :to="{ name: 'ContractsAddendumsRecord', params: {id: pendingAddendum.id} }">
                                            Open contractaanpassing {{ addendumReference(pendingAddendum) }}
                                        </router-link>
                                        <span v-if="pendingAddendum.status === 'pending_signature' && !pendingAddendum.file_id">
                                            &nbsp;– het addendum wordt binnenkort aangemaakt en verstuurd.
                                        </span>
                                    </p>
                                </b-notification>
                                <br>
                            </div>

                            <div class="row" v-if="_.has(record, 'step1.escalate_status') && !_.isNull(record.step1.escalate_status)">
                                <div class="column">
                                    <b-notification type="is-danger" :closable="false">
                                        <div class="columns is-vcentered" style="padding: 0;width: 103%">
                                            <div class="column is-9">
                                                Nieuwe facturen voor dit contract worden automatisch geëscaleerd
                                                <span v-if="record.step1.escalate_status == 'escalated_send'">naar de deurwaarder</span>
                                                wanneer ze worden aangemaakt.
                                            </div>
                                            <div class="column is-3 text-right">
                                                <b-button type="is-light" size="is-small" @click="disableAutoEscalationPrompt">Uitschakelen</b-button>
                                            </div>
                                        </div>
                                    </b-notification>
                                </div>
                            </div>

                            <div class="row">
                                <!-- Left column -->
                                <div class="column medium-6">
                                    <div v-if="loading" class="marginbottom15">
                                        <b-skeleton width="50%" height="30px" :animated="true"></b-skeleton>
                                    </div>
                                    <h2 v-else>Contract {{ record.step1.number }}</h2>

                                    <h2>Klant</h2>
                                    <div v-if="loading" class="marginbottom0">
                                        <b-skeleton width="40%" :animated="true"></b-skeleton>
                                        <b-skeleton width="30%" :animated="true"></b-skeleton>
                                        <b-skeleton width="45%" :animated="true"></b-skeleton>
                                        <b-skeleton width="25%" :animated="true"></b-skeleton>
                                    </div>
                                    <p class="marginbottom0" v-else>
                                        <strong>{{ hideSensitiveData ? '********' : record.step2?.customer?.firstname }} {{ hideSensitiveData ? '********' : record.step2?.customer?.lastname }}{{ record.step2?.customer?.type == 'business' ? ' ('+record.step2?.customer?.companyname+')' : '' }}</strong> <router-link :to="{ name: 'CustomersRecord', params: {id: record.step2?.customer?.id} }" size="is-small"><font-awesome-icon icon="edit" /></router-link><br>
                                        {{ hideSensitiveData ? '********' : record.step2?.customer?.email }}&nbsp;<CustomerMail v-if="record.step2?.customer && !user.deurwaarder" :customer="record.step2?.customer" :contract="$route.params.id" button-size="is-small" button-type="is-primary" @mailSent="$refs.CommunicationLogs.loadCorrespondingLogs()" /><br>
                                        <span v-if="record.step2?.customer?.telephone || record.step2?.customer?.mobile">
                                            <span v-if="record.step2?.customer?.telephone"><font-awesome-icon class="fa-w-16" icon="phone" flip="horizontal"/> {{ hideSensitiveData ? '********' : record.step2.customer.telephone }}</span>
                                            <span v-if="record.step2?.customer?.mobile"><span v-if="record.step2?.customer?.telephone"><br></span><font-awesome-icon class="fa-w-16" icon="mobile" /> {{ hideSensitiveData ? '********' : record.step2.customer.mobile }}</span><br>
                                        </span>
                                        <span v-else>Geen telefoonnummer<br></span>
                                        <span v-if="record.step2?.customer?.address || record.step2?.customer?.address2 || record.step2?.customer?.city || record.step2?.customer?.zip">
                                            {{ hideSensitiveData ? '********' : record.step2?.customer?.address }}&nbsp;{{ hideSensitiveData ? '********' : record.step2?.customer?.address2 }}<br>
                                            {{ hideSensitiveData ? '********' : record.step2?.customer?.zipcode }},&nbsp;{{ hideSensitiveData ? '********' : record.step2?.customer?.city }}
                                        </span>
                                        <span v-else>Geen adres</span>
                                    </p>

                                    <br>

                                    <div v-if="user.organisation_locations && user.organisation_locations.length > 1">
                                        <h2>Vestiging</h2>
                                        <div v-if="loading">
                                            <b-skeleton width="30%" :animated="true"></b-skeleton>
                                        </div>
                                        <p class="marginbottom0" v-else>{{ record.step1?.organisation_location?.name }} ({{ record.step1?.organisation_location?.city }})</p>
                                        <br>
                                    </div>

                                    <h2>Datums</h2>
                                    <div v-if="loading">
                                        <b-skeleton width="40%" :animated="true"></b-skeleton>
                                        <b-skeleton width="30%" :animated="true"></b-skeleton>
                                    </div>
                                    <div v-else>
                                        <b-field label="Startdatum"
                                            :message="getError(errors[1], 'start_date')"
                                            :type="getType(errors[1], 'start_date', '')"
                                        >
                                            {{ moment(record.step1.start_date).format('DD-MM-YYYY') }}
                                        </b-field>

                                        <div v-if="undetermined">Contract is voor onbepaalde tijd</div>

                                        <slide-up-down :active="!undetermined" :duration="500">
                                            <div class="row">
                                                <div class="column paddingbottom0">
                                                    <b-field label="Eind datum"></b-field>
                                                </div>
                                                <div class="column small-6 paddingtop0 medium-3 end">
                                                    <b-field
                                                        :message="getError(errors[1], 'length')"
                                                        :type="getType(errors[1], 'length', '')"
                                                    >
                                                        {{ moment(record.step1.end_date).format('DD-MM-YYYY') }}
                                                    </b-field>
                                                </div>
                                            </div>
                                        </slide-up-down>
                                    </div>

                                    <br>

                                    <h2>Betaling</h2>
                                    <div v-if="loading">
                                        <b-skeleton width="50%" :animated="true"></b-skeleton>
                                        <b-skeleton width="45%" :animated="true"></b-skeleton>
                                        <b-skeleton width="35%" :animated="true"></b-skeleton>
                                    </div>
                                    <div v-else>
                                        <b-field label="Facturatie frequentie"
                                            :message="getError(errors[1], 'invoice_freq')"
                                            :type="getType(errors[1], 'invoice_freq', '')"
                                        >
                                            {{ invoiceFreqLongLabel(record.step1.invoice_freq) }}
                                        </b-field>

                                        <b-field
                                            v-if="_.has(record, 'step1.payment_type')"
                                            label="Betaalmethode"
                                            :message="getError(errors[1], 'payment_type')"
                                            :type="getType(errors[1], 'payment_type', '')"
                                        >
                                            {{ record.step1.payment_type == 'incasso' ? 'Automatische incasso' : record.step1.payment_type == 'manual' ? 'Handmatig' : 'Onbekend' }}
                                            <a @click="show_change_payment_type_modal = true" class="m-l-5">
                                                <font-awesome-icon icon="edit" />
                                            </a>
                                        </b-field>
                                    </div>
                                </div>

                                <!-- Right column -->
                                <div class="column medium-6">
                                    <div class="card action-menu-card">
                                        <header class="card-header">
                                            <div class="level card-header-title">
                                                <div class="level-left">
                                                    <strong>Acties</strong>
                                                </div>
                                            </div>
                                        </header>
                                        <div class="card-content">
                                            <div v-if="loading">
                                                <b-skeleton width="100%" height="40px" :animated="true" class="mb-1"></b-skeleton>
                                                <b-skeleton width="100%" height="40px" :animated="true" class="mb-1"></b-skeleton>
                                                <b-skeleton width="100%" height="40px" :animated="true"></b-skeleton>
                                            </div>
                                            <div v-else>
                                                <nav class="menu is-spaced is-fullwidth">
                                                    <ul class="menu-list">
                                                        <li class="mb-1">
                                                            <router-link :to="{ name: 'CustomersRecord', params: {id: record.step2?.customer?.id} }">
                                                                <b-icon icon="user" class="mr-2" size="is-small" />
                                                                Klant bekijken
                                                            </router-link>
                                                        </li>
                                                        <li class="mb-1">
                                                            <ContractsSignDocumentsModal
                                                                ref="ContractsSignDocumentsModal"
                                                                :contractId="$route.params.id"
                                                                :show="finalized"
                                                                :contractHold="record?.step1?.hold || 0"
                                                                :isNewContract="!!($route.query && $route.query.nieuw)"
                                                                includedFrom="contract"
                                                                @reload="startUp"
                                                            />
                                                        </li>
                                                        <li v-if="!hideEndingContract" class="py-1">
                                                            <a
                                                                href="#"
                                                                class="action-menu-link"
                                                                :class="{ 'ended': !canCreateAddendum }"
                                                                @click.prevent="openCreateAddendum"
                                                            >
                                                                <b-icon icon="edit" class="mr-2" size="is-small" />
                                                                Contract aanpassen
                                                            </a>
                                                        </li>
                                                        <li v-if="!hideEndingContract" class="py-1">
                                                            <router-link
                                                                :to="{ name: 'ContractsPriceChangesRecord', params: {id: 'nieuw'}, query: {'contract': $route.params.id} }"
                                                                class="action-menu-link"
                                                            >
                                                                <b-icon icon="euro-sign" class="mr-2" size="is-small" />
                                                                Prijswijziging aanmaken
                                                            </router-link>
                                                        </li>
                                                        <li v-if="!hideEndingContract" class="py-1">
                                                            <a  href="#"
                                                                class="action-menu-link"
                                                                :class="{ 'ended': finalized }"
                                                                style="box-shadow:none;"
                                                                :disabled="finalized"
                                                                @click.prevent="(finalized || loading) ? null : show_end_contract_modal = true"
                                                            >
                                                                <b-icon icon="times-circle" class="mr-2" size="is-small" />
                                                                <span v-if="finalized">Contract is beëindigd</span>
                                                                <span v-else>Contract beëindigen</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Klant">
                            <div v-show="record.step2.customer_id">
                                <CRUDCustomer
                                    ref="CRUDcustomer"
                                    :id="record.step2.customer_id"
                                    :getCustomer="record.step2.customer"
                                    @fullPageLoader="fullPageLoader"
                                    @customerSaved="handleCustomerSaved"
                                    :showAlert="true"
                                />
                            </div>
                            <!-- <div v-show="!record.step2.customer_id">
                                <FindCustomer
                                    ref="findCustomer"
                                    :showAllCustomers="record.step2.customer_id ? false : true"
                                />
                            </div> -->
                        </b-tab-item>

                        <b-tab-item label="Borg">
                            <CustomerCredits
                                ref="CustomerCredits"
                                :customerId="record.step2.customer_id"
                                :contractId="$route.params.id"
                            />
                        </b-tab-item>

                        <b-tab-item label="Prijswijzigingen">
                            <div class="text-right">
                                <router-link v-if="!user.deurwaarder" :to="{ name: 'ContractsPriceChangesRecord', params: {id: 'nieuw'}, query: {'contract': $route.params.id} }">
                                    <b-button type="is-primary">Prijswijziging aanmaken</b-button>
                                </router-link>
                            </div>

                            <ContractsPriceChangeTable
                                ref="ContractsPriceChangeTable"
                                :contract="$route.params.id"
                            />
                        </b-tab-item>

                        <b-tab-item label="Toegang" v-if="user && user.role == 'pit' && user.organisation_connect  && !user.deurwaarder">
                            <template slot="header">
                                Toegang&nbsp;
                                <b-icon v-if="connectLoaded" icon="key" size="is-small" :class="{
                                    'has-text-danger': hasValidAccess === false,
                                    'has-text-success': hasValidAccess === true,
                                    'has-text-grey': hasValidAccess === null
                                }" />
                                <b-icon v-else icon="spinner" size="is-small" class="fa-spin" />
                            </template>

                            <div class="row">
                                <div class="column small-7">
                                    <h1 class="title">Toegang</h1>
                                </div>
                                <div class="column small-5 text-right">
                                    <b-button type="is-primary" tag="router-link" :to="`/panel/connect/nieuw?contract=${$route.params.id}&customer=${record.step2.customer_id}`">Toegang aanmaken</b-button>
                                </div>
                            </div>
                            <ConnectTable
                                ref="ConnectTable"
                                :contract="$route.params.id"
                                @open="setHasValidAccess"
                                @connectloaded="connectLoaded = true"
                            />
                        </b-tab-item>
                    </b-tabs>
                </form>
            </div>
        </div>

        <!-- Producten -->
        <div class="row">
            <div class="column">
                <form class="form verticalpadding">
                    <div class="row">
                        <div class="column is-flex is-justify-content-space-between is-align-items-center">
                            <h3>Product<span v-show="products && products.length > 1">en</span></h3>
                            <b-button
                                type="is-dark"
                                :disabled="!canCreateAddendum"
                                @click="openCreateAddendum"
                            >
                                Aanpassen
                            </b-button>
                        </div>
                    </div>

                    <!-- Discount indicator -->
                    <div class="row" v-if="!loading && hasProductsWithDiscounts">
                        <div class="column">
                            <b-message type="is-info" :closable="false">
                                <!-- <b-icon icon="percent" size="is-small"></b-icon> -->
                                <strong>Op de volgende producten is een korting van toepassing:</strong>
                                <ul style="margin-top: 0.5rem; margin-bottom: 0;">
                                    <li v-for="item in discountSummary" :key="item.productId">
                                        <strong>{{ item.productName }}</strong>: {{ item.discountText }}
                                    </li>
                                </ul>
                            </b-message>
                        </div>
                    </div>

                    <div class="row">
                        <div class="column">
                            <!-- Products skeleton -->
                            <div v-if="loading">
                                <b-skeleton height="30px" :animated="true"></b-skeleton>
                                <b-skeleton height="30px" :animated="true"></b-skeleton>
                            </div>
                            <ProductsSummary
                                v-else
                                includedIn="ContractsRecordView"
                                :type="mode"
                                :products="products"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Contractaanpassingen -->
        <div class="row" v-if="!loadingAddendums && addendums.length > 0">
            <div class="column">
                <form class="form verticalpadding" :class="{ 'is-compact': !loadingAddendums && addendums.length === 0 }">
                    <div class="row">
                        <div class="column is-flex is-justify-content-space-between is-align-items-center">
                            <h3>Contractaanpassingen</h3>
                            <b-button
                                type="is-dark"
                                :disabled="!canCreateAddendum"
                                @click="openCreateAddendum"
                            >
                                Toevoegen
                            </b-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column">
                            <b-table
                                v-if="loadingAddendums || addendums.length > 0"
                                :data="addendums"
                                :loading="loadingAddendums"
                                :striped="true"
                                :mobile-cards="true"
                            >
                                <template>
                                    <b-table-column v-slot="props" field="id" label="Referentie" width="170">
                                        <router-link :to="{ name: 'ContractsAddendumsRecord', params: { id: props.row.id } }">
                                            <strong>{{ addendumReference(props.row) }}</strong>
                                        </router-link>
                                    </b-table-column>
                                    <b-table-column v-slot="props" field="effective_date" label="Ingangsdatum" width="170">
                                        {{ moment(props.row.effective_date).format('DD-MM-YYYY') }}
                                    </b-table-column>
                                    <b-table-column v-slot="props" field="status" label="Status" width="220">
                                        <b-tag :type="addendumStatusTagType(props.row.status)">
                                            {{ addendumStatusLabel(props.row.status) }}
                                        </b-tag>
                                    </b-table-column>
                                    <b-table-column v-slot="props" field="created_at" label="Aangemaakt op" width="170">
                                        {{ moment(props.row.created_at).format('DD-MM-YYYY') }}
                                    </b-table-column>
                                    <b-table-column v-slot="props" numeric width="200">
                                        <router-link :to="{ name: 'ContractsAddendumsRecord', params: {id: props.row.id} }">
                                            <b-button type="is-dark" size="is-small">Bekijken</b-button>
                                        </router-link>
                                    </b-table-column>
                                </template>
                                <template #empty>
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p class="margin0" v-if="!loadingAddendums">Nog geen contractaanpassingen.</p>
                                            <p class="margin0" v-else>Laden...</p>
                                        </div>
                                    </section>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Facturen -->
        <div class="row">
            <CreateCreditInvoiceButton
                ref="CreateCreditInvoiceButton"
                :customerId="record?.step2.customer_id"
                :number="String($route.params.id)"
                :contractId="$route.params.id"
                :products="depositProducts"
                :deposit_products="depositProducts"
                :extraProducts="creditExtraProducts"
                :endDate="selectedEndDate"
                :hideTheButton="true"
            />

            <div class="column">
                <form class="form verticalpadding">
                    <div class="row is-flex">
                        <div class="column is-flex is-justify-content-space-between is-align-items-center">
                            <h3>Facturen</h3>
                            <!-- <b-switch v-model="showCancelledInvoices">
                                Toon geannuleerde facturen
                            </b-switch> -->

                            <b-field class="cancelledswitch">
                                <span class="label">Toon geannuleerde facturen</span><b-switch :disabled="loading" v-model="showCancelledInvoices"></b-switch>
                            </b-field>
                        </div>
                        <!-- <div class="column small-6 text-right">
                            <b-button type="is-primary" outlined tag="router-link" :to="{ name: 'CreateInvoiceRecord', query: { customer: record.step2.customer_id } }">Losse factuur maken</b-button>
                            <b-button type="is-danger" outlined tag="router-link" :to="{ name: 'CreditInvoiceRecord', query: { customer: record.step2.customer_id } }">Creditfactuur maken</b-button>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="column">
                            <!-- Invoices skeleton -->
                            <div v-if="loading">
                                <b-skeleton height="40px" :animated="true"></b-skeleton>
                                <b-skeleton height="30px" :animated="true"></b-skeleton>
                                <b-skeleton height="30px" :animated="true"></b-skeleton>
                            </div>
                            <InvoicesTable
                                v-show="!loading"
                                ref="InvoicesTable"
                                type="contract"
                                :id="$route.params.id"
                                :showCancelledOrders="showCancelledInvoices"
                                @hasMoreInvoices="hasMoreInvoices = $event"
                            />

                            <NextInvoiceStatusMessage
                                :contract="record.step1"
                                :hasMoreInvoices="hasMoreInvoices"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>

         <!--- Bestanden -->
         <div class="row">
            <div class="column">
                <form class="form verticalpadding">
                    <div class="row">
                        <div class="column">
                            <h3>Bestanden</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column">
                            <VueFileAgent
                                ref="vueFileAgent"
                                :theme="'list'"
                                :multiple="true"
                                :deletable="showDeletingFile"
                                accept="image/*,.pdf,.doc,.docx,.odt,.rtf,.txt"
                                :meta="true"
                                :maxSize="'10MB'"
                                :maxFiles="25"
                                :readonly="hideUploading"
                                :linkable="true"
                                :helpText="'Kies afbeeldingen, PDF-bestanden, documenten en tekstbestanden.'"
                                :errorText="{
                                    type: 'Enkel afbeeldingen, PDF-bestanden, documenten en tekstbestanden zijn mogelijk.',
                                    size: 'Bestanden dienen kleiner te zijn dan 10MB.',
                                }"
                                @select="filesSelected($event)"
                                @beforedelete="onBeforeDelete($event)"
                                @delete="fileDeleted($event)"
                                v-model="contractFilesModel"
                            ></VueFileAgent>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <!-- Communicatielog -->
        <div v-if="loading">
            <div class="row">
                <div class="column">
                    <h3>Communicatielog</h3>
                    <b-skeleton height="100px" :animated="true"></b-skeleton>
                    <b-skeleton height="100px" :animated="true"></b-skeleton>
                    <b-skeleton height="100px" :animated="true"></b-skeleton>
                    <b-skeleton height="100px" :animated="true"></b-skeleton>
                </div>
            </div>
        </div>
        <CommunicationLogs
            v-else
            ref="CommunicationLogs"
            type="contract"
            :logs="logs"
            :loading="loading"
            :customer="record.step2.customer"
            :contract="$route.params.id"
            @startUp="startUp"
        />
    </div>
</template>

<script>
import Vue from 'vue'
import CRUDCustomer from '@/vue/CRUDCustomer'
import FindCustomer from '@/vue/FindCustomer'
import ProductsSummary from '@/vue/products/components/ProductsSummary'
import ContractsRecordEndContractModal from './ContractsRecordEndContractModal'
import ContractsRecordConfirmStopModal from './ContractsRecordConfirmStopModal'
import ContractsSignDocumentsModal from './ContractsSignDocumentsModal'
import ChangePaymentTypeModal from './components/ChangePaymentTypeModal'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixins from '@/mixins/toastMixins.js'
import InvoicesTable from '@/vue/invoices/components/InvoicesTable'
import ContractsPriceChangeTable from './pricechanges/ContractsPriceChangeTable'
import CommunicationLogs from '@/vue/CommunicationLogs'
import CustomerCredits from '@/vue/customers/CustomerCredits'
import CreateCreditInvoiceButton from '@/vue/creditinvoice/CreateCreditInvoiceButton'
import ConnectTable from '@/vue/connect/components/ConnectTable'
import CustomerMail from '@/vue/customers/components/CustomerMail'
import invoiceFreqMixin from '@/mixins/invoiceFreqMixin'
import NextInvoiceStatusMessage from './components/NextInvoiceStatusMessage'

export default {
    name: 'ContractsRecordView',

    components: {
        CRUDCustomer,
        FindCustomer,
        ContractsRecordConfirmStopModal,
        ContractsRecordEndContractModal,
        ContractsSignDocumentsModal,
        InvoicesTable,
        ContractsPriceChangeTable,
        CommunicationLogs,
        ProductsSummary,
        CreateCreditInvoiceButton,
        ConnectTable,
        ChangePaymentTypeModal,
        CustomerMail,
        CustomerCredits,
        NextInvoiceStatusMessage
    },

    mixins: [formvalidationMixin, toastMixins, invoiceFreqMixin],

    data() {
        return {
            loading: true, // Start with loading state true
            tabIndex: 0,

            mode: 'view',
            saving: false,
            activeStep: 0,
            showFormFooter: true,
            validatedSteps: {
                step0: false,
                step1: false,
                step2: false,
                step3: false,
                step4: false
            },

            products: [],
            depositProducts: [],
            selectedEndDate: null,
            creditExtraProducts: [],

            contractExpirationDate: null,
            undetermined: true,
            hasMoreInvoices: true, // Default to true, updated by InvoicesTable component

            record: {
                step1: {
                    start_date: moment().startOf('day')._d,
                    length: 0,
                },
                step2: {
                    customer_id: null
                },
                step3: {
                    boxes: [],
                    products: []
                }
            },
            errors: {},

            show_create_modal: false,
            create_status: '',

            show_end_contract_modal: false,
            show_change_payment_type_modal: false,

            finalized: false,

            confirmStop: false,
            confirmStopType: '',
            show_confirm_stop_modal: false,

            fileRecords: [],
            uploadUrl: `/api/contract/${this.$route.params.id}/upload`,
            fileRecordsForUpload: [], // maintain an upload queue

            // Comment
            logs: [],

            // Connect
            connectLoaded: false,
            hasValidAccess: null,

            addendums: [],
            loadingAddendums: false,
            showCancelledInvoices: false,
            isStartingUp: false
        }
    },

    computed: {
        pageTitle() {
            if (this.user?.organisation_type === 'box' && this.products.length > 0) {
                const boxProducts = this.products.filter(p => p.type === 'box')
                if (boxProducts.length > 0) {
                    const boxNumbers = boxProducts.map(box => box.name)

                    if (boxNumbers.length === 1) {
                        return `Contract van ${boxNumbers[0].toLowerCase()}`
                    } else if (boxNumbers.length === 2) {
                        return `Contract van ${boxNumbers[0].toLowerCase()} en ${boxNumbers[1].toLowerCase()}`
                    } else {
                        const lastNumber = boxNumbers.pop()
                        return `Contract van ${boxNumbers.join(', ').toLowerCase()} en ${lastNumber.toLowerCase()}`
                    }
                }
            }

            return 'Contract bekijken'
        },

        user() {
            return this.$store.state.user
        },

        invoiceType() {
            return moment(new Date(this.record.step1.start_date)).format('D') < 15 ? 'pre15' : 'after15'
        },

        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        hasProductsWithDiscounts() {
            return this.products && this.products.some(product =>
                product.discounts && product.discounts.length > 0
            )
        },

        discountSummary() {
            if (!this.products) return [];

            const summary = [];

            this.products.forEach(product => {
                if (product.discounts && product.discounts.length > 0) {
                    // Group discounts
                    const applyToAllDiscount = product.discounts.find(d => d.apply_to_all);

                    if (applyToAllDiscount) {
                        const discountText = applyToAllDiscount.type === 'percentage'
                            ? `${applyToAllDiscount.value}%`
                            : `€${applyToAllDiscount.value}`;
                        summary.push({
                            productId: product.id,
                            productName: product.name,
                            discountText: `${discountText}${product.once ? '' : ' (alle facturen)'}`
                        });
                    } else {
                        // Show specific invoice discounts
                        const discountsByInvoice = product.discounts.map(d => {
                            const discountValue = d.type === 'percentage' ? `${d.value}%` : `€${d.value}`;
                            return `${discountValue} (factuur ${d.invoice || 1})`;
                        }).join(', ');

                        summary.push({
                            productId: product.id,
                            productName: product.name,
                            discountText: discountsByInvoice
                        });
                    }
                }
            });

            return summary;
        },

        hideEndingContract() {
            let hideEndingContract = false

            if(_.has(this.user.organisation_settings, 'strictcontracts') && this.user.organisation_settings.strictcontracts == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                hideEndingContract = true
            }

            return hideEndingContract
        },

        hideUploading() {
            let hideUploading = false

            if(_.has(this.user.organisation_settings, 'contractfileupload') && this.user.organisation_settings.contractfileupload == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                hideUploading = true
            }

            return hideUploading
        },

        showDeletingFile() {
            let showDeletingFile = true

            if(_.has(this.user.organisation_settings, 'contractfiledelete') && this.user.organisation_settings.contractfiledelete == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                showDeletingFile = false
            }

            return showDeletingFile
        },

        customerMandateReference() {
            if (this.record?.step2?.customer?.mandate) {
                return this.record.step2.customer.mandate.mandate_reference;
            }
            // Fallback to old contract mandate for backwards compatibility during migration
            return this.record?.step1?.mandate || null;
        },

        pendingAddendum() {
            if (!this.addendums || this.addendums.length === 0) {
                return null
            }

            return this.addendums.find(item =>
                item.status === 'pending_signature' || item.status === 'pending_processing'
            ) || null
        },
        canCreateAddendum() {
            return !this.pendingAddendum
        },
        contractFilesModel: {
            get() {
                return this.sanitizeFileRecords(this.record?.step1?.contract_files)
            },
            set(value) {
                if (!this.record || !this.record.step1) return
                this.record.step1.contract_files = this.sanitizeFileRecords(value)
            }
        }
    },

    created(){
        // Set a minimum loading time to ensure skeletons are visible
        setTimeout(() => {
            this.startUp()
        }, 500)
    },

    mounted() {
        if(this.$route.query.cancel && this.$route.query.cancel == true){
            this.show_end_contract_modal = true
        }
    },

    methods: {
        startUp(){
            if (this.isStartingUp) {
                return
            }

            console.log('[🔥] Fetch contract', this.$route.params.id)
            this.isStartingUp = true
            this.loading = true // Set loading state to true
            this.fullPageLoader(true)

            this.showFormFooter = false

            // Make all steps valid
            _.each(this.validatedSteps, (val, key) => {
                this.validatedSteps[key] = true
            })

            axios.get('/api/contract/'+this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.setData(response.data)
                this.logs = response.data.contract_logs
                return this.fetchAddendums()

                // Open cancelmodal
                if(_.has(this.$route, 'query.cancel') && this.$route.query.cancel == 'true'){
                    this.show_end_contract_modal = true
                }
            }).catch((error) => {
                this.$buefy.toast.open({message: 'Error: Contract kan niet geopend worden!', type: 'is-danger'})
                this.$router.push({name: 'ContractsOverview'})
            }).then(() => {
                setTimeout(() => {
                    this.loading = false // Set loading state to false when data is loaded
                    this.fullPageLoader(false)
                    this.isStartingUp = false
                }, 1000)
            })

            this.calculateContractEndDate()
        },

        fetchAddendums() {
            this.loadingAddendums = true

            return axios.get(`/api/contract/${this.$route.params.id}/addendums`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.addendums = response.data || []
            }).catch(() => {
                this.addendums = []
            }).then(() => {
                this.loadingAddendums = false
            })
        },
        openCreateAddendum() {
            if (!this.canCreateAddendum) {
                this.showError('Er staat al een open contractaanpassing klaar.')
                if (this.pendingAddendum) {
                    this.$router.push({
                        name: 'ContractsAddendumsRecord',
                        params: { id: this.pendingAddendum.id }
                    })
                }
                return
            }

            this.$router.push({
                name: 'ContractsAddendumsRecord',
                params: { id: 'nieuw' },
                query: { contract: this.$route.params.id }
            })
        },

        addendumStatusLabel(status) {
            switch (status) {
            case 'pending_signature':
                return 'Wachten op bevestiging'
            case 'pending_processing':
                return 'Klaar voor verwerking'
            case 'applied':
                return 'Gereed'
            case 'cancelled':
                return 'Geannuleerd'
            default:
                return status
            }
        },

        addendumStatusTagType(status) {
            switch (status) {
            case 'pending_signature':
                return 'is-warning'
            case 'pending_processing':
                return 'is-info'
            case 'applied':
                return 'is-success'
            case 'cancelled':
                return 'is-danger'
            default:
                return 'is-light'
            }
        },
        addendumReference(addendum) {
            if (!addendum) {
                return '-'
            }

            const contractNumber = this.record?.step1?.number || this.$route.params.id
            const sequence = this.getAddendumSequence(addendum)
            return `${contractNumber}-${String(sequence).padStart(2, '0')}`
        },
        getAddendumSequence(addendum) {
            if (!addendum || !this.addendums || this.addendums.length === 0) {
                return 1
            }

            const sorted = [...this.addendums].sort((a, b) => Number(a.id) - Number(b.id))
            const index = sorted.findIndex(item => Number(item.id) === Number(addendum.id))
            return index >= 0 ? index + 1 : 1
        },

        setData(data){
            // Step 1 (General)
            Vue.set(this, 'undetermined', (data['length'] == 0 && _.isNull(data['end_date'])) ? true : false)

            Vue.set(this.record, 'step1', {
                'organisation': data.organisation,
                'start_date': new Date(data.start_date),
                'length': data['length'],
                'period': data.period,
                'contract_files': this.sanitizeFileRecords(data.contract_files),
                'invoice_freq': data.invoice_freq,
                'payment_type': data.payment_type,
                'end_date': data.end_date,
                'contract_pdf': data.contract_pdf,
                'general_pdf': data.general_pdf,
                'mandate': data.mandate,
                'contractInQueue': data.contractInQueue,
                'contractInQueueWithPDFs': data.contractInQueueWithPDFs,
                'escalate_status': data.escalate_status,
                'organisation_location': data.organisation_location,
                'finalized': data.finalized,
                'hold': data.hold,
                'confirm_stop': data.confirm_stop,
                'next_invoice_date': data.next_invoice_date,
                'pending_addendum': data.pending_addendum,
                'number': data.number
            })

            // Is this contract finalized?
            this.finalized = !!data.finalized
            this.confirmStop = data.confirm_stop == 1

            // Step 2 (Customer)
            Vue.set(this.record, 'step2', {
                'customer_id': data.customer.id,
                'customer': data.customer
            })

            // Set products
            Vue.set(this, 'products', data.contract_products)
        },
        sanitizeFileRecords(fileRecords) {
            if (!Array.isArray(fileRecords)) {
                return []
            }

            return fileRecords.filter((fileRecord) => {
                if (!fileRecord || typeof fileRecord !== 'object') {
                    return false
                }

                return Boolean(fileRecord.id || _.has(fileRecord, 'upload.data.id'))
            })
        },

        calculateContractEndDate(){
            if(this.record.step1.length && this.record.step1.period){
                if(this.invoiceType == 'pre15'){
                    if(this.record.step1.length == 1){
                        this.contractExpirationDate = moment(this.record.step1.start_date).endOf('month')
                    } else {
                        this.contractExpirationDate = moment(this.record.step1.start_date).endOf('month').add((this.record.step1.length - 1), this.record.step1.period)
                    }
                } else {
                    this.contractExpirationDate = moment(this.record.step1.start_date).endOf('month').add(this.record.step1.length, this.record.step1.period)
                }
            }
        },

        fullPageLoader(value){
            this.saving = value
        },

        // types: stop or extend
        promptConfirmStop(type) {
            this.confirmStopType = type
            this.show_confirm_stop_modal = true
        },

        // File upload
        uploadFiles() {
            // Using the default uploader. You may use another uploader instead.
            this.$refs.vueFileAgent.upload(this.uploadUrl, {'Authorization': 'bearer ' + this.$store.state.authToken}, this.fileRecordsForUpload).then(() => {
                this.showMessage('Bestand geupload!')
                this.startUp() // TODO; only refetch the contract files, not the entire contract.
            }).catch((error) => {
                if(_.has(error[0], 'response.data.error') && error[0].response.data.error == 'not-org-admin'){
                    this.showError('Uploaden niet mogelijk, enkel een administrator is gemachtigd om bestanden te uploaden.')
                }
            })

            this.fileRecordsForUpload = []
        },

        deleteUploadedFile(fileRecord) {
            if (!fileRecord) return false;

            const fileId = _.has(fileRecord, 'upload.data.id') ? fileRecord.upload.data.id : fileRecord.id
            if(!fileId) return false;

            axios.delete(`${this.uploadUrl}/${fileId}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage('Bestand is verwijderd!')
                this.startUp()
            }).catch(() => {
                this.showError('Bestand kon niet verwijderd worden!')
            })
        },

        filesSelected(fileRecordsNewlySelected) {
            if (!fileRecordsNewlySelected) return;

            let validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => fileRecord && !fileRecord.error)
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)

            if (this.fileRecordsForUpload.length > 0) {
                this.uploadFiles()
            }
        },

        closeEndContractModal() {
            this.show_end_contract_modal = false
            this.$refs['InvoicesTable'].loadAsyncData()
        },

        handleChangePaymentSuccess() {
            this.show_change_payment_type_modal = false
            this.startUp()
        },

        loadPriceChanges(){
            try {
                if(this.$refs['ContractsPriceChangeTable'].loaded) return

                this.$refs['ContractsPriceChangeTable'].getSearchParams().then(() => {
                    this.$refs['ContractsPriceChangeTable'].loadAsyncData()
                })
            } catch (error) {
                console.log('Cant load price changes', error)
            }
        },

        // Handle the showCreditInvoiceModal event from the mixin
        showCreditInvoiceModal(payload) {
            this.startUp()

            if (payload && typeof payload === 'object') {
                this.depositProducts = payload.products.filter(p => parseFloat(p.deposit || 0) > 0)
                this.creditExtraProducts = payload.products.filter(p => parseFloat(p.price || 0) > 0 && parseFloat(p.deposit || 0) === 0)
                this.selectedEndDate = payload.endDate || null

                setTimeout(() => this.$refs.CreateCreditInvoiceButton.toggleModal(), 500)
            }
        },

        onBeforeDelete(fileRecord) {
            if (!fileRecord) return;

            let i = this.fileRecordsForUpload.indexOf(fileRecord);

            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                var k = this.fileRecords.indexOf(fileRecord);
                if (k !== -1) this.fileRecords.splice(k, 1);
            } else {
                if (confirm('Weet je zeker dat je het bestand wil verwijderen?')) {
                    if(this.showDeletingFile){
                        this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
                    } else {
                        this.showError('Bestand verwijderen is niet mogelijk, enkel een administrator is gemachtigd om bestanden te verwijderen.')
                    }
                }
            }
        },
        fileDeleted(fileRecord) {
            if (!fileRecord) return;

            let i = this.fileRecordsForUpload.indexOf(fileRecord)

            if (i !== -1) {
                this.fileRecordsForUpload.splice(i, 1)
            } else {
                this.deleteUploadedFile(fileRecord)
            }
        },
        disableAutoEscalationPrompt() {
            this.$buefy.dialog.confirm({
                title: 'Automatisch escaleren uitschakelen',
                message: 'Weet je zeker dat je het automatisch escaleren van de facturen wilt uitschakelen? Deze actie kan niet ongedaan worden gemaakt.',
                confirmText: 'Uitschakelen',
                cancelText: 'Annuleren',
                type: 'is-warning',
                onConfirm: () => {
                    this.disableAutoEscalation();
                }
            });
        },
        disableAutoEscalation() {
            this.fullPageLoader(true);
            axios.post(`/api/contract/${this.$route.params.id}/disable-auto-escalation`, {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage('Automatisch escaleren is uitgeschakeld.');
                this.startUp(); // Reload contract data
            }).catch((error) => {
                console.error('[❌] Error disabling auto-escalation:', error);
                this.showError('Automatisch escaleren kon niet worden uitgeschakeld. Probeer het opnieuw.');
            }).then(() => {
                this.fullPageLoader(false);
            });
        },

        // Set the hasValidAccess variable, to show if the box is connected with an connect access
        setHasValidAccess(hasValidAccess){
            this.hasValidAccess = hasValidAccess
        },

        // Handle customer saved event - reload contract to show updated mandate status
        handleCustomerSaved() {
            // Reload contract data to reflect any mandate changes (e.g., bank number change)
            this.startUp()
        }
    },

    watch: {
        undetermined: function(newVal, oldVal){
            if(this.mode != 'saving'){
                Vue.set(this.record.step1, 'length', newVal ? 0 : 2)
                Vue.set(this.record.step1, 'period', 'months')
            }
        },

        tabIndex: function(newVal, oldVal) {
            // Load price changes when "Prijswijzigingen" tab (index 3) becomes active
            if (newVal === 3) {
                this.loadPriceChanges()
            }
            // Load deposits (Borg) when Borg tab (index 2) becomes active
            if (newVal === 2) {
                this.$nextTick(() => {
                    this.$refs.CustomerCredits?.fetchUserCredits()
                })
            }
        }
    }
}
</script>

<style scoped>
.subtle-text {
    text-align: center;
    color: #a2a2a2;
    margin-top: 10px;
}

.is-subtle-empty-state {
    margin-top: 0.5rem;
    padding: 0.25rem 0.5rem;
}

.is-compact {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
</style>
